import React, {FC, memo} from "react";
import {GridAreaContentLayout} from "./GridAreaContentLayout";
import {useStateValue} from "../state-provider/StateProvider";
import './BrandFollowForm.css'
import {GridAreaContentLayoutLine} from "./components/GridAreaContentLayoutLine";
import {GridAreaContentLayoutTextField} from "./GridAreaContentLayoutTextField";
import {GridAreaContentLayoutButton} from "./GridAreaContentLayoutButton";
import {LayoutSpacing} from "./components/LayoutSpacing";
import {ws} from "../../events/ws";
import {setBrandFollowing, setGridAreaContent, setUserEmail} from "../app/App.action";
import {sendToWidget} from "../../utils/postMessages";
import {log} from "../../utils/log";
import {WiStars} from "react-icons/wi";
import {IoNotificationsOutline} from "react-icons/io5";
import {useEmail} from "../../hooks/useEmail";

const BrandFollowForm2Component: FC<{

}> =
({

}) => {

  const [{ brand, translations, brandFollowing, userEmail }, dispatch] = useStateValue()

  const { email, setEmail, isValid: isEmailValid } = useEmail(userEmail ?? "")

  const dismiss = () => {
    dispatch(setGridAreaContent('Grid'))
  }

  const follow = async (e: any) => {

    e.preventDefault()
    const timezone = new Intl.DateTimeFormat().resolvedOptions().timeZone
    try {
      ws.sendFollowRequest(
        email!!,
        timezone,
      )
      dispatch(setUserEmail({ userEmail: email }))
      sendToWidget({ type: 'update-user-email', value: email })
      dispatch(setBrandFollowing(true))

      setTimeout(() => {
        dismiss()
      }, 3000)
    } catch (err) {
      log(`Error following`, err)
    }
  }

  return (
    <GridAreaContentLayout
      footer={(
        <>
        { !brandFollowing ? (
          <>
            <GridAreaContentLayoutButton onClick={follow} disabled={!isEmailValid} label={translations['FollowFormSubmitLabel'] || "Follow"} icon={<IoNotificationsOutline />}/>
            <GridAreaContentLayoutLine variant={"Compact"} text={translations['FollowFormExplanationLabel']}/>
          </>
          ) : (
          <>
            <GridAreaContentLayoutButton onClick={dismiss} label={translations['FollowFormFollowingLabel']} icon={<WiStars/>}/>
          </>
        )}
        </>
      )}
    >
      <div className={"brand-follow-form-title-container"}>
        <div className="brand-follow-form-avatar">
          <img src={brand?.imageLink}/>
        </div>
        <GridAreaContentLayoutLine text={brand?.title}/>
      </div>
      <LayoutSpacing/>
      <GridAreaContentLayoutLine text={brand?.profileDescriptionForFollowers}/>
      <LayoutSpacing/>
      { !brandFollowing && (
        <>
          <GridAreaContentLayoutTextField label={translations['FollowFormInputEmailLabel']} value={email} setValue={setEmail}/>
          <LayoutSpacing/>
        </>
      )}
    </GridAreaContentLayout>
  )
}

export const BrandFollowForm2 = memo(BrandFollowForm2Component)